import { useRef } from "react";
import { UserButton } from "@clerk/clerk-react";

export const SideNavUserButton = ({ tpUser }) => {
  const userButtonRef = useRef<HTMLDivElement>(null);

  const handleWrapperClick = () => {
    const button = userButtonRef.current?.querySelector("button");
    if (button) {
      button.click();
    }
  };

  return (
    <div className="mt-auto border-t border-slate-800">
      <div
        onClick={handleWrapperClick}
        data-testid="user-menu-button"
        className="flex items-center gap-3 p-4 hover:bg-slate-800 transition-colors cursor-pointer group"
      >
        {/* 3. Wrap UserButton in a div with the ref */}
        <div ref={userButtonRef} className="pointer-events-none">
          <UserButton afterSignOutUrl="/" />
        </div>

        <div className="flex-1 min-w-0">
          <div
            data-testid="user-name"
            className="text-sm font-medium text-white truncate"
          >
            {tpUser.name}
          </div>
          <div className="text-xs text-slate-500 truncate">{tpUser.email}</div>
        </div>
      </div>
    </div>
  );
};
